import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { api, type Me } from './api';
import { useAuth } from './auth';

const MeContext = createContext<Me | null>(null);

export function MeProvider({ children }: { children: ReactNode }) {
  const { session } = useAuth();
  const [me, setMe] = useState<Me | null>(null);

  useEffect(() => {
    if (!session || session.role !== 'team') {
      setMe(null);
      return;
    }
    void (async () => {
      try {
        setMe(await api<Me>('/api/me/team'));
      } catch {
        setMe(null);
      }
    })();
  }, [session]);

  return <MeContext.Provider value={me}>{children}</MeContext.Provider>;
}

export function useMe(): Me | null {
  return useContext(MeContext);
}

export function useIsSuperAdmin(): boolean {
  const me = useMe();
  return me?.role === 'super_admin';
}
